import { cn } from '@/lib/utils'
import { HugeiconsIcon, type IconSvgElement } from '@hugeicons/react'
import { FieldLabel as ShadFieldLabel } from '@/components/ui/field'
import { Show } from '@/components/show'

export interface FieldLabelProps {
  label?: React.ReactNode
  labelComponent?: React.ReactNode
  disabled?: boolean
  error?: boolean
  htmlFor?: string
  required?: boolean
  subheading?: string
  href?: string
  onTertiaryLabelClick?: () => void
  tertiaryLabelIcon?: IconSvgElement
}

export const FieldLabel = ({
  disabled,
  error = false,
  htmlFor,
  label,
  labelComponent,
  required,
  subheading,
  href,
  onTertiaryLabelClick,
  tertiaryLabelIcon
}: FieldLabelProps) => {
  const displayTertiary =
    !!tertiaryLabelIcon && (!!href || !!onTertiaryLabelClick)

  return (
    <div className='flex w-full justify-between'>
      <ShadFieldLabel
        htmlFor={htmlFor}
        className={cn(error && !disabled && 'text-red-500')}
      >
        <span>
          {labelComponent ?? label}
          <Show when={!required && !!label && !labelComponent}>
            <span className='text-muted-foreground text-xs font-normal'>
              {' '}
              optional
            </span>
          </Show>
        </span>
      </ShadFieldLabel>
      <Show when={!!subheading}>
        <p className='text-muted-foreground text-xs'>{subheading}</p>
      </Show>
      <Show when={displayTertiary}>
        {href ? (
          <a href={href} aria-label={`Link to ${href}`}>
            <HugeiconsIcon
              strokeWidth={2}
              className='support-link-icon size-4.5'
              icon={tertiaryLabelIcon!}
            />
          </a>
        ) : (
          <button
            type='button'
            onClick={onTertiaryLabelClick}
            aria-label='Open help'
          >
            <HugeiconsIcon
              strokeWidth={2}
              className='support-link-icon size-4.5'
              icon={tertiaryLabelIcon!}
            />
          </button>
        )}
      </Show>
    </div>
  )
}
